<template>
    <div
        class="af-login-widget-loggedin afu-relative"
        v-click-outside="closeMenu"
    >
        <a
            href="#"
            class="af-login-widget-profile afu-flex afu-items-center afu-justify-center afu-border afu-border-solid afu-border-gray-300 afu-bg-gray-600 afu-bg-opacity-10 afu-p-2 hover:afu-no-underline afu-text-center afu-text-gray-600 hover:afu-text-gray-900 afu-text-sm"
            @click.prevent.default="onClick()"
        >
            <FontAwesomeIcon
                :icon="['far', 'user-circle']"
                class="afu-mr-2"
            />
            Profile
        </a>

        <div
            v-show="isOpen"
            class="af-menu-dropdown afu-absolute afu-z-50"
            style="left: 50%; margin: 0 0 0 -130px; width: 260px;"
        >
            <div class="afu-relative afu-pt-3">
                <div
                    class="af-menu-dropdown-arrow afu-absolute afu-top-0 afu-left-0 afu-right-0 afu--mt-5 afu-text-6xl afu-text-white afu-mx-auto"
                    style="width: 30px;"
                >
                    <FontAwesomeIcon
                        :icon="['fas', 'sort-up']"
                    />
                </div>

                <SeekerMenu />
            </div>
        </div>
    </div>
</template>

<script>
    import SeekerMenu from '@/apps/login-widget/001/components/SeekerMenu';

    export default {
        name: 'LoggedIn',

        components: {
            SeekerMenu,
        },

        data() {
            return {
                isOpen: false,
            };
        },

        methods: {
            onClick() {
                this.isOpen = !this.isOpen;
            },

            closeMenu() {
                this.isOpen = false;
            },
        },
    };
</script>
